// Creates a local image of the visible Plumme viewport for customer support.
// The renderer is loaded only when the user explicitly requests a screenshot.
(function (global) {
  const HTML2CANVAS_SCRIPT = 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js';
  const HTML2CANVAS_INTEGRITY = 'sha512-BNaRQnYJYiPSqHHDb58B0yaPfCu+Wgds8Gp/gU33kqBtgNS4tSPHuGibyoeqMV/TJlSKda6FXzoEyYGjTe+vXA==';

  const loadRenderer = () => {
    if (global.html2canvas) return Promise.resolve(global.html2canvas);
    if (global.__plummeSupportScreenshotLoading) return global.__plummeSupportScreenshotLoading;
    global.__plummeSupportScreenshotLoading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = HTML2CANVAS_SCRIPT;
      script.async = true;
      script.integrity = HTML2CANVAS_INTEGRITY;
      script.crossOrigin = 'anonymous';
      script.onload = () => global.html2canvas
        ? resolve(global.html2canvas)
        : reject(new Error('screenshot-renderer-unavailable'));
      script.onerror = () => {
        global.__plummeSupportScreenshotLoading = null;
        reject(new Error('screenshot-renderer-unavailable'));
      };
      document.head.appendChild(script);
    });
    return global.__plummeSupportScreenshotLoading;
  };

  const screenshotName = (date = new Date()) => {
    const stamp = date.toISOString().slice(0, 19).replace(/[T:]/g, '-');
    return `plumme-screenshot-${stamp}.png`;
  };

  const canvasBlob = (canvas) => new Promise((resolve, reject) => {
    canvas.toBlob((blob) => blob
      ? resolve(blob)
      : reject(new Error('screenshot-encode-failed')), 'image/png');
  });

  const prepareClone = (clonedDocument) => {
    const topbar = clonedDocument.querySelector('.topbar');
    if (!topbar) return;
    // html2canvas can rasterize the live fade-to-transparent header background
    // as a dark strip. Keep the app unchanged and flatten only the cloned header.
    topbar.style.backgroundImage = 'none';
    topbar.style.backgroundColor = 'var(--topbar-bg)';
    topbar.style.boxShadow = 'none';
    topbar.style.filter = 'none';
  };

  const captureVisiblePage = async ({ renderer, date } = {}) => {
    const render = renderer || await loadRenderer();
    await document.fonts?.ready?.catch?.(() => {});
    const viewportWidth = Math.max(1, global.innerWidth || document.documentElement.clientWidth || 1);
    const viewportHeight = Math.max(1, global.innerHeight || document.documentElement.clientHeight || 1);
    const scrollX = Number(global.scrollX || global.pageXOffset || 0);
    const scrollY = Number(global.scrollY || global.pageYOffset || 0);
    const canvas = await render(document.documentElement, {
      allowTaint: false,
      backgroundColor: global.getComputedStyle(document.body).backgroundColor || '#ffffff',
      height: viewportHeight,
      ignoreElements: (element) => element.hasAttribute?.('data-support-screenshot-ignore'),
      logging: false,
      onclone: prepareClone,
      scale: Math.min(Math.max(Number(global.devicePixelRatio) || 1, 1), 2),
      scrollX,
      scrollY,
      useCORS: true,
      width: viewportWidth,
      windowHeight: viewportHeight,
      windowWidth: viewportWidth,
      x: scrollX,
      y: scrollY,
    });
    const blob = await canvasBlob(canvas);
    return new File([blob], screenshotName(date), { type: 'image/png', lastModified: Date.now() });
  };

  global.PlummeSupportScreenshot = Object.freeze({ captureVisiblePage, screenshotName });
})(typeof window !== 'undefined' ? window : globalThis);
